import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SectionHeading } from '@/components/home/SectionHeading';
import { WhatsAppCta } from '@/components/home/WhatsAppCta';
import { WA_MESSAGES } from '@/lib/whatsapp';
import { HOME_FAQS } from '@/lib/home-faq';
import { HOME } from '@/constants/testIds';

export const FAQ = () => (
  <section id="faq" data-testid={HOME.faqSection} className="gg-section gg-faq">
    <div className="gg-container gg-faq-grid">
      <div><SectionHeading id="faq" eyebrow="SEBELUM ANDA BOOKING" title="Soalan yang elok dijelaskan dulu.">Tentang pakej, bayaran dan apa yang berlaku selepas anda hubungi kami.</SectionHeading><WhatsAppCta testId="faq-whatsapp-cta" message={WA_MESSAGES.general}>Tanya di WhatsApp</WhatsAppCta></div>
      <Accordion type="single" collapsible defaultValue="q-1" className="gg-accordion">
        {HOME_FAQS.map((item, i) => <AccordionItem key={item.q} value={`q-${i}`} data-testid={`faq-item-${i}`}><AccordionTrigger data-testid={`faq-question-${i}`} data-track="faq_toggle" className="gg-faq-question">{item.q}</AccordionTrigger><AccordionContent data-testid={`faq-answer-${i}`} className="gg-faq-answer">{item.a}</AccordionContent></AccordionItem>)}
      </Accordion>
    </div>
  </section>
);

export default FAQ;